import { FC, PropsWithChildren } from 'react';

import { cn } from '@savgroup-front-common/primitive/lib/utils';

import { HaloStatus } from './DesignationHalo.types';

interface DesignationHaloProps extends PropsWithChildren {
  status: HaloStatus;
  className?: string;
  dataTestId?: string;
}

export const DesignationHalo: FC<DesignationHaloProps> = ({
  status,
  className,
  dataTestId,
  children,
}) => (
  <div
    data-testid={dataTestId}
    data-status={status}
    className={cn('ai-halo rounded-lg', className)}
  >
    {children}
  </div>
);
